<template>
  <div class="page">
     <div class="headerNav">
      <div class="nav">
        <div class="nav_content">我的发票</div>
      </div>
      <div class="nav-left" @click="goBack"><img src="../../assets/new/left_b.svg" alt="" /></div>
    </div>
    <div class="header">
      <van-tabs @click="onClick" color="#2A70F2" title-active-color="#2A70F2">
        <van-tab title="申请发票">
          <div class="group_1">
            <div v-if="invoiceInfo.length > 0">
              <div class="box_1" v-for="item in invoiceInfo" :key="item.id">
                <div class="title">订单号：{{ item.ordNo }}</div>
                <van-divider />
                <div class="title_1">
                  <div class="text_1">订单金额</div>
                  <div class="text_2">{{ Number(item.ordMoneysum).toFixed(2) }}元</div>
                </div>
                <div class="title_1">
                  <div class="text_1">支付时间</div>
                  <div class="text_2">{{ item.ordPaytime }}</div>
                </div>
                <div class="title_1">
                  <div class="text_1">购买班级</div>
                  <div class="text_2">{{ item.className }}</div>
                </div>

                <van-divider />
                <div class="btn">
                  <div
                    class="btn_1"
                    @click="handleinvoice(item)"
                    v-if="
                      item.invoiceClaimType != '02' &&
                      item.ordMoneysum != 0 &&
                      item.ordPaytime != null &&
                      item.ordPaytime != '' &&
                      item.ordPaytime.indexOf(nyear) > -1
                    "
                  >
                    点击开发票
                  </div>
                  <div
                    class="btn_2"
                    v-if="
                      item.invoiceClaimType != '02' &&
                      ((item.ordPaytime != null && item.ordPaytime != '' && item.ordPaytime.indexOf(nyear) == -1) ||
                        (item.ordPaytime == null && item.ordPaytime == ''))
                    "
                  >
                    发票不支持跨年领取
                  </div>
                  <div
                    class="btn_2"
                    style="color: red; border: 1px solid red"
                    v-if="item.invoiceClaimType == '02' && item.ordPaytime != null && item.ordPaytime != ''"
                  >
                    已申请发票
                  </div>
                  <div
                    class="btn_2"
                    v-if="
                      item.invoiceClaimType != '02' &&
                      item.ordPaytime != null &&
                      item.ordPaytime != '' &&
                      item.ordPaytime.indexOf(nyear) > -1 &&
                      item.ordMoneysum == 0
                    "
                  >
                    订单支付金额为0
                  </div>
                </div>
              </div>
            </div>
            <van-empty description="暂无订单" v-else />
            <div @click="loadMore" v-if="hasMore" class="load-more">点击加载更多</div>
            <div v-else class="no-more">没有更多数据了~</div>
          </div>
        </van-tab>
        <van-tab title="发票记录">
          <div class="group_2">
            <div v-if="list.length > 0">
              <div class="box_2" v-for="item1 in list" :key="item1.id">
                <div class="title_1">
                  <div class="text_1">开票时间</div>
                  <div class="text_2">{{ item1.invoiceTime }}</div>
                </div>
                <div class="title_1">
                  <div class="text_1">开票金额</div>
                  <div class="text_2">{{ Number(item1.invoicePrice).toFixed(2) }}元</div>
                </div>
                <van-divider />
                <!-- <div style="display: flex; justify-content: flex-end"><div class="btn_3" @click="gotoDetail(item1)">查看详情</div></div> -->
                <div style="display: flex; justify-content: flex-end"><div class="btn_3" @click="gotoDetail(item1)">下载发票</div></div>

              </div>
            </div>
            <van-empty description="暂无发票" v-else />
            <div @click="loadMore" v-if="hasMore" class="load-more">点击加载更多</div>
            <div v-else class="no-more">没有更多数据了~</div>
          </div>
        </van-tab>
      </van-tabs>
    </div>
  </div>
</template>
<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
// 例如：import 《组件名称》 from '《组件路径》';
import { toEOrderInvoiceList, toOrderList,toEOrderInvoiceDetail } from '../../api/myInvoice';
var odate = new Date();
var oyear = odate.getFullYear();
export default {
  // import引入的组件需要注入到对象中才能使用
  components: {},
  data() {
    // 这里存放数据
    return {
      invoiceInfo: [],
      pageSize: 6,
      pageNum: 1,
      total: '',
      hasMore: true,
      list: [],
      nyear: oyear,
      name: 0
    };
  },
  // 监听属性 类似于data概念
  computed: {},
  // 监控data中的数据变化
  watch: {},
  // 方法集合
  methods: {
    //切换tab
    onClick(name, title) {
      this.pageNum = 1;
      if (name == '0') {
        this.name = 0;
         window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
        this.toOrderList();
      } else if (name == '1') {
        this.name = 1;

        this.getInvoice();
         this.$nextTick(() => {
          const scrollContainer = document.querySelector('.page');
          if (scrollContainer) {
            scrollContainer.scrollTo({
              top: 0,
              behavior: 'smooth'
            });
          }
        });
      }
    },
    //去开发票
    handleinvoice(item) {
      this.$router.push({
        path: '/invoicing',
        query: {
          id: item.id
        }
      });
    },
    //
    goBack(){
      this.$router.push({
        path: '/my',
      
      });
    },
    // 获取发票记录列表
    getInvoice() {
      const data = {
        pageSize: this.pageSize,
        pageNum: this.pageNum
      };
      toEOrderInvoiceList(data).then(res => {
        if (this.pageNum == 1) {
          this.list = res.data.rows;

        } else {
          this.list = [...this.list, ...res.data.rows];
        }
        this.total = res.data.total;
        this.hasMore = this.list.length < this.total;
      });
    },
    //获取发票列表
    toOrderList() {
      const data = {
        pageSize: this.pageSize,
        pageNum: this.pageNum
      };
      toOrderList(data).then(response => {
        if (this.pageNum == 1) {
          this.invoiceInfo = response.data.rows;
          window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
        } else {
          this.invoiceInfo = [...this.invoiceInfo, ...response.data.rows];
        }
        this.total = response.data.total;
        this.hasMore = this.invoiceInfo.length < this.total;
      });
    },
    //去详情页
   gotoDetail(item) {
  if (item && item.invoicePdf) { 
    const link = document.createElement('a');
    link.href = item.invoicePdf; 
    link.download = 'invoice.pdf'; 
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  } else {
    console.error('发票PDF链接不可用');
  }
},
    loadMore() {
      this.pageNum++;
      if (this.name == 0) {
        this.toOrderList();
      } else {
        this.getInvoice();
      }
    },
  
  },
  // 生命周期 - 创建完成（可以访问当前this实例）
  created() {
    this.toOrderList();
    
  },
  // 生命周期 - 挂载完成（可以访问DOM元素）
    mounted() {
    this.$nextTick(() => {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    });
  },
  beforeCreate() {}, // 生命周期 - 创建之前
  beforeMount() {} // 生命周期 - 挂载之前
};
</script>
<style lang="less" scoped>
/* //@import url(); 引入公共css类 */
.page {
  background-color: #f6f8fa;
  height: 100vh;
  overflow-y: scroll;
}
.load-more,
.no-more {
  text-align: center;
  padding: 10px;
  font-size: 14px;
  color: #999;
}
.no-more {
  color: #666;
}
.group_1 {
  padding: 56px 15px;
}
.box_1 {
  // width: 345px;
  margin-bottom: 10px;
  padding: 16px 15px;
  height: 248px;
  background: #ffffff;
  border-radius: 8px 8px 8px 8px;
  .title {
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    font-size: 13px;
    color: #333333;
  }

  .btn {
    font-family: PingFang SC, PingFang SC;
    display: flex;
    justify-content: flex-end;
    font-weight: 400;
    font-size: 13px;
    .btn_1 {
      width: 108px;
      height: 36px;
      border-radius: 18px 18px 18px 18px;
      border: 1px solid #2a70f2;
      text-align: center;
      line-height: 36px;
      color: #2a70f2;
    }
    .btn_2 {
      width: 140px;
      height: 36px;
      border-radius: 18px 18px 18px 18px;
      border: 1px solid #b2b2b2;
      color: #999999;
      text-align: center;
      line-height: 36px;
    }
  }
}
.title_1 {
  margin-bottom: 16px;
  display: flex;
  justify-content: space-between;
  .text_1 {
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    font-size: 14px;
    color: #333333;
  }
  .text_2 {
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    font-size: 14px;
    color: #667280;
    width: 200px;
    text-align: right;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
}
.group_2 {
  padding: 56px 15px;
}
.box_2 {
  // width: 345px;
  margin-bottom: 10px;
  padding: 16px 15px;
  height: 165px;
  background: #ffffff;
  border-radius: 8px 8px 8px 8px;

  .btn_3 {
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    font-size: 13px;
    color: #666666;
    text-align: center;
    line-height: 36px;
    width: 108px;
    height: 36px;
    border-radius: 18px 18px 18px 18px;
    border: 1px solid #666666;
  }
}
::v-deep {
  .van-tabs__line {
    width: 24px;
    height: 2px;
    border-radius: 2px 2px 2px 2px;
    margin-bottom: 4px;
  }
}
.headerNav {
  position: fixed;
  top: 0;
  width: 100%;
  height: 46px;
  background: #fff;
  border-radius: 0px 0px 0px 0px;
  z-index: 99;
}
.nav {
  padding: 0 15px;
  height: 46px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
}
.nav-left {
  position: absolute;
  top: 15px;
  left: 15px;
}
.nav_content {
  font-family: PingFang SC, PingFang SC;
  font-weight: 600;
  font-size: 17px;
  color: #333;
}
::v-deep {
.van-tabs__line {
    width: 24px;
    height: 2px;
    border-radius: 2px 2px 2px 2px;
    margin-bottom: -7px;
    // margin-top: 10px;
  }
  .van-tabs__nav {
    position: fixed;
    top: 46px;
    left: 0;
    right: 0;
    width: 100%;
    height: 46px;
    padding-top: 0px;
    padding-bottom: 0px;
    overflow-y: scroll;
  }
  .van-tabs__content {
    // margin: 56px 0;
    // padding: 0 15px;
    // padding:56px 15px;
    height: 100vh;
    // overflow-y: scroll;
  }
}
</style>
